import {
  adminScopeUnavailableMessage,
  type AdminProfile,
  type AdminScopeStatus,
} from "./AdminScopeContext";

export function adminCanUseCustomerVoice(
  profile: AdminProfile | null,
): boolean {
  if (!profile) return false;
  if (profile.isSuperAdmin) return true;
  if (profile.role === "store_manager") return profile.storeId !== null;
  return (
    profile.role === "area_manager" ||
    profile.role === "owner" ||
    profile.role === "finance"
  );
}

export function adminCustomerVoiceUnavailableMessage(
  status: AdminScopeStatus,
  profile: AdminProfile | null,
): string {
  if (status === "connected" && profile && !adminCanUseCustomerVoice(profile)) {
    return "桌访与客诉工作台仅对店长、区域负责人、财务、老板和超级管理员开放。";
  }
  return adminScopeUnavailableMessage(status);
}
